import { createAsyncThunk } from "@reduxjs/toolkit";
import { GraphQLClient } from "../../../../../../../shared/gql-client";
import { PackingSlipModel } from "../../../../domain/models/packingSlipModel";
import PackingSlipService from "../../../service/packingSlipService";

const packingSlipApi = new PackingSlipService();

export const updatePlanningPackingSlipPickupAmount = createAsyncThunk(
  "planning/packing-slip/update/pickup",
  async (
    { value, packingSlip }: { value: string; packingSlip: PackingSlipModel },
    thunkAPI,
  ) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    let response = undefined;

    try {
      packingSlipApi.setClient(client);

      const newAmount = parseFloat(value);

      if (isNaN(newAmount) || newAmount < 0) return;

      response = await packingSlipApi.mutate({
        id: { type: "ID!", value: packingSlip.id },
        date: { type: "Date!", value: packingSlip.date },
        relation_id: { type: "ID!", value: packingSlip.relation.id },
        status: { type: "String!", value: packingSlip.status },
        pickup_amount: {
          type: "Int",
          value: newAmount,
        },
      });

      console.log(response);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
